import React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './LevelUp.module.scss'
import PythonLogo from './assets/logo-python.svg'
import JSLogo from './assets/logo-js.svg'
import JavaLogo from './assets/logo-java.svg'
import Badge from '../badge/Badge'
import SectionHead from '../section-head/SectionHead'
import ProgressBar from '../progress-bar/ProgressBar'

const LevelUp: React.FC = () => {
  const t = useIntl()

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <SectionHead
          title={t.formatMessage({ id: 'levelup.title' })}
          text={
            <>
              {t.formatMessage({ id: 'levelup.subtitle1' })}
              <br />
              {t.formatMessage({ id: 'levelup.subtitle2' })}
            </>
          }
        />
        <div className={styles.badges}>
          <Badge
            style={{ animationName: styles.fadeAndTranslate1Left }}
            className={`${styles.firstToGo} ${styles.badgeLeft}`}
          >
            <StaticImage
              src='./assets/pz_100_ascii_art_01_unlocked.png'
              alt=''
              width={33}
              height={18}
            />
          </Badge>
          <Badge
            style={{ animationName: styles.fadeAndTranslate2Left }}
            className={`${styles.secondToGo} ${styles.badgeLeft}`}
          >
            <StaticImage
              src='./assets/pz_50_the_last_crusade_03_unlocked.png'
              alt=''
              width={29}
              height={30}
            />
          </Badge>
          <Badge
            style={{ animationName: styles.fadeAndTranslate3Left }}
            className={`${styles.thirdToGo} ${styles.badgeLeft}`}
          >
            <StaticImage
              src='./assets/pz_50_mission_to_mars_03_unlocked.png'
              alt=''
              width={41}
              height={28}
            />
          </Badge>
          <Badge
            style={{ animationName: styles.fadeAndTranslate4Left }}
            className={`${styles.shiftBehindLeft} ${styles.badgeLeft}`}
          >
            <StaticImage
              src='./assets/cd_godfather_1_friend_unlocked.png'
              alt=''
              width={31}
              height={26}
            />
          </Badge>

          <div
            className={styles.languageLogoContainer}
          >
            <PythonLogo
              className={styles.languageLogo}
            />
            <JSLogo
              className={styles.languageLogo}
              style={{ animationName: styles.logoSecond }}
            />
            <JavaLogo
              className={styles.languageLogo}
              style={{ animationName: styles.logoThird }}
            />
          </div>

          <Badge
            style={{ animationName: styles.fadeAndTranslate4Right }}
            className={`${styles.shiftBehindRight} ${styles.badgeRight}`}
          >
            <StaticImage
              src='./assets/pz_100_the_resistance_01_unlocked.png'
              alt=''
              width={38}
              height={17}
            />
          </Badge>
          <Badge
            style={{ animationName: styles.fadeAndTranslate3Right }}
            className={`${styles.thirdToGo} ${styles.badgeRight}`}
          >
            <StaticImage
              src='./assets/pz_50_tan_network_01_unlocked.png'
              alt=''
              width={28}
              height={31}
            />
          </Badge>
          <Badge
            style={{ animationName: styles.fadeAndTranslate2Right }}
            className={`${styles.secondToGo} ${styles.badgeRight}`}
          >
            <StaticImage
              src='./assets/pz_100_super_computer_01_unlocked.png'
              alt=''
              width={24}
              height={31}
            />
          </Badge>
          <Badge
            style={{ animationName: styles.fadeAndTranslate1Right }}
            className={`${styles.firstToGo} ${styles.badgeRight}`}
          >
            <StaticImage
              src='./assets/pz_100_mime_type_01_unlocked.png'
              alt=''
              width={23}
              height={26}
            />
          </Badge>
        </div>

        <ProgressBar />

      </div>
    </div>
  )
}

export default LevelUp
